import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import MemberPage from "../components/cowork/MemberPage";
import BuyerDashboard from "../components/cowork/BuyerDashboard";
import SellerDashboard from "../components/cowork/SellerDashboard";
import ProfileForm from "../components/cowork/ProfileForm";

function DashboardBody({ user, settings, setUser }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab") === "profile" ? "profile" : "main";
  const [showForm] = useState(searchParams.get("new") === "1");
  const goTo = (next) => setSearchParams(next === "profile" ? { tab: "profile" } : {}, { replace: true });

  return (
    <>
      <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
        <div>
          <p className="text-accent-light uppercase tracking-widest text-sm font-semibold capitalize">{user.role} Dashboard</p>
          <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight mt-1">Hello, {user.full_name || user.email}</h1>
        </div>
        <div className="flex items-center gap-2">
          {[["main", user.role === "buyer" ? "My Jobs" : "My Proposals"], ["profile", "My Profile"]].map(([key, label]) => (
            <button
              key={key}
              onClick={() => goTo(key)}
              className={`px-5 py-2 rounded-full text-sm font-semibold transition-colors ${
                tab === key ? "bg-brand-gradient text-white" : "bg-white/5 border border-navy-border text-gray-300 hover:text-white"
              }`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      {tab === "profile" ? (
        <ProfileForm user={user} onSaved={setUser} />
      ) : user.role === "buyer" ? (
        <BuyerDashboard settings={settings} startWithForm={showForm} />
      ) : (
        <SellerDashboard settings={settings} />
      )}
    </>
  );
}

// The buyer / seller dashboard. The signed-in member's role decides which one they get.
export default function CoWorkDashboardPage() {
  return <MemberPage title="Dashboard">{(ctx) => <DashboardBody {...ctx} />}</MemberPage>;
}
